import blog1 from "../../Assets/img/blog/freepik__candid-image-photography-natural-textures-highly-r__73741.jpeg";

const blogsData = {
  categories: [
    {
      name: "Academic Tips",
      blogs: [
        {
          title: "How to Write Perfect Essays",
          link: "/blogs/how-to-write-perfect-essays",
        },
        {
          title: "Time Management Tips for Students",
          link: "/blogs/time-management-tips",
        },
        {
          title: "Citing Sources Effectively",
          link: "/blogs/citing-sources-effectively",
        },
      ],
    },
    {
      name: "Study Abroad",
      blogs: [
        {
          title: "Top Destinations for Students",
          link: "/blogs/top-destinations-for-students",
        },
        {
          title: "How to Apply for Scholarships",
          link: "/blogs/how-to-apply-for-scholarships",
        },
        {
          title: "Cultural Adjustment Tips",
          link: "/blogs/cultural-adjustment-tips",
        },
      ],
    },
    {
      name: "Career Guidance",
      blogs: [
        {
          title: "Building a Strong Resume",
          link: "/blogs/building-a-strong-resume",
        },
        {
          title: "Mastering Job Interviews",
          link: "/blogs/mastering-job-interviews",
        },
        {
          title: "Choosing the Right Career Path",
          link: "/blogs/choosing-the-right-career-path",
        },
      ],
    },
  ],
  mostRecent: [
    {
      title: "Understanding Plagiarism in Academia",
      description:
        "Learn what plagiarism is, why it matters, and how to avoid it in your academic work.",
      link: "/blogs/understanding-plagiarism",
      image: blog1,
      date: "December 27, 2024",
      content: `
        Plagiarism is a serious offense in academia, with severe consequences. 
        In this article, we explore the definition of plagiarism, discuss its ethical implications, 
        and provide actionable tips to ensure that your work remains original and properly credited.
      `,
    },
    {
      title: "5 Tips for Effective Online Learning",
      description:
        "Maximize your online learning experience with these practical tips and strategies.",
      link: "/blogs/online-learning-tips",
      image: blog1,
      date: "December 20, 2024",
      content: `
        Online learning offers flexibility but comes with its own challenges. 
        This blog provides five essential tips to help students stay focused, organized, and motivated 
        while learning online. From setting up a productive workspace to mastering time management, 
        we've got you covered!
      `,
    },
    {
      title: "Navigating Group Projects Successfully",
      description:
        "Discover strategies for collaboration and conflict resolution in group projects.",
      link: "/blogs/navigating-group-projects",
      image: blog1,
      date: "December 15, 2024",
      content: `
        Group projects can be both rewarding and challenging. 
        Learn how to assign roles effectively, communicate openly, and resolve conflicts professionally 
        to ensure that your group achieves its goals without unnecessary stress.
      `,
    },
    {
      title: "Effective Note-Taking Strategies",
      description:
        "Enhance your academic success with proven note-taking techniques and methods.",
      link: "/blogs/note-taking-strategies",
      image: blog1,
      date: "December 10, 2024",
      content: `
        Good note-taking is key to academic success. 
        This article delves into various methods, including the Cornell Method, mind mapping, and outlining, 
        to help you retain information effectively and prepare better for exams.
      `,
    },
    {
      title: "Balancing Academics and Social Life",
      description:
        "Find out how to manage your time effectively to balance study and personal life.",
      link: "/blogs/balancing-academics-and-social-life",
      image: blog1,
      date: "December 5, 2024",
      content: `
        Striking a balance between academics and social activities is essential for mental well-being. 
        Explore practical tips on time management, prioritization, and creating a sustainable routine 
        that supports both your academic goals and personal growth.
      `,
    },
  ],
};

export default blogsData;
